<template>
<v-layout row wrap style="margin-top: 40px">
  <v-flex xs12 class="text-center">
      <h2>{{defunt.sexe=='Féminin' ? 'Verstorbene': 'Verstorbener'}}</h2>
  </v-flex>
    <v-flex xs12 sm12 md6>
    <v-layout row wrap>
      <v-flex xs6>
        <v-radio-group v-model="defunt.sexe" @change="sexeChanged(defunt.sexe)" row>
          <v-flex xs6>
            <v-radio label="Männlich" value="Masculin"></v-radio>
          </v-flex>
          <v-flex xs6>
            <v-radio label="Weiblich" value="Féminin"></v-radio>
          </v-flex>
        </v-radio-group> 
        </v-flex>
        <v-flex xs6>
          <v-text-field filled label="Nummer" v-model="defunt.num"></v-text-field>
        </v-flex>
        <v-flex xs12>
        <v-select filled v-model="defunt.titre" label="Anrede" v-bind:items="defunt.sexe=='Masculin' ? titreMasc : titreFem" :menu-props="{maxHeight:'auto'}" item-value="text"></v-select>
        </v-flex>
        <v-flex xs6>
        <v-text-field filled @input="prenomChangeg(defunt.prenom)" label="Vorname" v-model="defunt.prenom"></v-text-field>
        </v-flex>
        <v-flex xs6>
        <v-text-field filled @input="nomChangeg(defunt.nom)" label="Name" v-model="defunt.nom"></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="defunt.sexe=='Féminin'">
        <v-text-field filled v-model="defunt.nomJf" label="Ledigname"></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
        <v-text-field filled v-model="defunt.dateNaiss" type="date" label="Geburtsdatum"></v-text-field>
        </v-flex>
        <v-flex xs12 sm8>
        <v-text-field filled v-model="defunt.lieuNaiss" label="Geburtsort"></v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
        <v-text-field filled v-model="defunt.dateDeces" type="date" label="Todesdatum"></v-text-field>
        </v-flex>
        <v-flex xs12 sm8>
        <v-combobox filled v-model="defunt.lieuDeces" label="Todesort" :items="listeLieuDeces"></v-combobox>
        </v-flex>
        <v-flex xs12>
        <v-combobox filled v-model="defunt.lieuDepotCorps" label="Hinterlegung des Verstorbenen" :items="listeLieuDepotCorps"></v-combobox>
        </v-flex>
        <v-flex xs6>
        <v-autocomplete :loading="isLoadingAdress" outlined return-object clearable hide-no-data :items="itemsAdr" label="Suche Adresse" item-text="descript" :search-input.sync="autoAdress" v-model="adresseSearch" @change="adrSelected(adresseSearch)">
        </v-autocomplete>
        </v-flex>
        <v-flex xs6>
        <v-text-field filled v-model="defunt.adresse" label="Adresse"></v-text-field>
        </v-flex>
        <v-flex xs3>
        <v-text-field filled v-model="defunt.cp" type="number" label="PLZ"></v-text-field>
        </v-flex>
        <v-flex xs9>
        <v-text-field filled v-model="defunt.loc" label="Ort"></v-text-field>
        </v-flex>
    </v-layout>
    </v-flex>

    <v-flex xs12 sm12 md6>
    <v-layout row wrap>
        <v-flex xs4>
        <v-select filled item-value="text" v-bind:items="defunt.sexe=='Masculin' ? etatCivMasc : etatCivFem" label="Zivilstand" v-model="defunt.etatCivil"></v-select>              
        </v-flex>
        <v-flex xs8 v-if="defunt.etatCivil=='Verheiratet'">
        <v-text-field filled v-model="defunt.conjoint" label="Ehepartner"></v-text-field>
        </v-flex>
        <v-flex xs12>
        <v-combobox filled v-model="defunt.confession" label="Konfession" v-bind:items="confessions" :menu-props="{maxHeight:'auto'}"></v-combobox>
        </v-flex>
        <v-flex xs6>
        <v-autocomplete outlined hide-no-data clearable :items="itemsOr" item-text="localite" v-model="originSearch" :loading="isLoadingOrigin" :search-input.sync="lieuOrigine" @change="originSelected(originSearch)" label="Suche Heimatort">
        </v-autocomplete>
        </v-flex>
        <v-flex xs6>
          <v-text-field filled v-model="defunt.lieuOrigine" label="Heimatort"></v-text-field>
        </v-flex>
        <v-flex xs6>
        <v-combobox filled :items="listeProfessions" v-model="defunt.profession" label="Beruf"></v-combobox>
        </v-flex>
        <v-flex xs12>
        <v-text-field filled v-model="defunt.filiation" label="Abstammung"></v-text-field>
        </v-flex>
        <v-flex xs12>
        <v-textarea outlined v-model="defunt.remarque" label="Bemerkungen" multi-line></v-textarea>
        </v-flex>
        <v-flex xs12 class="text-center">
          <v-btn large color="primary" :loading="saveLoad" :disabled="saveLoad" @click.native="save()">Speichern</v-btn>
        </v-flex>
    </v-layout>
    </v-flex>

    <v-btn fab fixed color="warning" :loading="saveLoad" :disabled="saveLoad" @click.native="save()"><v-icon>mdi-content-save</v-icon></v-btn>

     <v-dialog eager v-model="dialog" max-width="250px">
      <v-card>
        <v-card-title>
          <span class="headline">Hausnummer</span>
        </v-card-title>
        <v-card-text>
          <v-text-field filled ref="numRue" label="Nummer" v-model="numero"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="numChoisi(numero)">Ok</v-btn>
          <v-btn @click="dialog = false">Schliessen</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

</v-layout>
</template>

<script>
    import {ajax, ajax_post} from '../../public/global.js'
    export default {
      data(){
        return{
          defunt: {
            num: '',
            sexe: 'Masculin',
            titre: '',
            prenom: '',
            nom:'',
            nomJf: '',
            dateNaiss: '',
            lieuNaiss: '',
            dateDeces: '',
            lieuDeces: '',
            lieuDepotCorps: '',
            adresse: '',
            cp: '',
            loc: '',
            etatCivil: '',
            conjoint: '',
            confession: '',
            lieuOrigine: '',
            profession: '',
            filiation: '',
            remarque: ''
          },
          titreMasc: [
            {text: 'Herr'}
          ],
          titreFem: [
            {text: 'Frau'}
          ],
          etatCivMasc: [
            {text: 'Verheiratet'},
            {text: 'Verwitwet'},
            {text: 'Ledig'},
            {text: 'Geschieden'}
          ],
          etatCivFem: [
            {text: 'Verheiratet'},
            {text: 'Verwitwet'},
            {text: 'Ledig'},
            {text: 'Geschieden'}
          ],
          confessions: [
            'Katholisch',
            'Protestantisch',
            'Orthodoxe',
            'Muslimische',
            'Jüdisch',
          ],
          listeLieuDeces: [
            'Domizil',
            'HFR Freibourg',
            'HFR Tafers'
          ],
          listeLieuDepotCorps: [
            'HFR Freibourg',
            'HFR Tafers',
            'CURML',
            'Inselspital Bern'
          ],
          listeProfessions: [
            'AHV',
            'IV'
          ],
          lieuOrigine: null,
          itemsOr: [],
          itemsAdr:[],
          autoAdress: null,
          adresseSearch:'',
          originSearch:'',
          numero: '',
          dialog: false,
          loading: false,
          isLoadingOrigin: false,
          isLoadingAdress: false,
          saveLoad: false
        }
      },
      methods: {
        adrSelected(adrSelected){
          if(adrSelected != null){
            this.defunt.adresse = adrSelected.adresse
            this.defunt.cp = adrSelected.cp
            this.defunt.loc = adrSelected.loc
            this.dialog = true
            this.$nextTick(this.$refs.numRue.focus)
          }
        },
        test(){
          this.$root.$emit('myinfo', 'test')
        },
        originSelected(originSelected){
          if(originSelected != null){
            this.defunt.lieuOrigine = originSelected
          }
        },
        numChoisi(numero){
          this.defunt.adresse = this.defunt.adresse + ' ' + numero
          this.dialog = false
        },
        sexeChanged(val){
          this.$root.$emit('sexeChang', val)
        },
        prenomChangeg(val){
          this.$root.$emit('prenomChang', val)
        },
        nomChangeg(val){
          this.$root.$emit('nomChang', val)
        },
        fetchData () {
          this.loading = true
          ajax_post(`/PHP/ajax/returnDef.php`,`id=${this.$route.params.id}&token=${this.$token()}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              let defuntRecup = rep.data
              this.defunt.num = defuntRecup.num
              this.defunt.sexe = defuntRecup.sexe
              this.defunt.titre = defuntRecup.titre
              this.defunt.prenom = defuntRecup.prenom
              this.defunt.nom = defuntRecup.nom
              this.defunt.nomJf = defuntRecup.nom_jf
              this.defunt.dateNaiss = defuntRecup.date_naissance
              this.defunt.dateDeces = defuntRecup.date_deces
              this.defunt.lieuDeces = defuntRecup.lieu_deces
              this.defunt.lieuDepotCorps = defuntRecup.lieu_depot_corps
              this.defunt.lieuNaiss = defuntRecup.lieu_naissance
              this.defunt.adresse = defuntRecup.adresse
              this.defunt.cp = defuntRecup.cp
              this.defunt.loc = defuntRecup.localite
              this.defunt.etatCivil = defuntRecup.etat_civil
              this.defunt.conjoint = defuntRecup.nom_conjoint
              this.defunt.confession = defuntRecup.confession
              this.defunt.lieuOrigine = defuntRecup.lieu_origine
              this.defunt.profession = defuntRecup.profession
              this.defunt.filiation = defuntRecup.filiation
              this.defunt.remarque = defuntRecup.remarque
              this.loading = false
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },

        saveNext(){
          this.saveLoad = true
          ajax_post(`/PHP/ajax/saveDef.php`, `id=${this.$route.params.id}&token=${this.$token()}&sexe=${this.defunt.sexe}&num=${this.defunt.num}&titre=${this.defunt.titre}&prenom=${this.defunt.prenom}&nom=${this.defunt.nom}&nom_jf=${this.defunt.nomJf}&date_naissance=${this.defunt.dateNaiss}&date_deces=${this.defunt.dateDeces}&lieu_deces=${this.defunt.lieuDeces}&lieu_depot_corps=${this.defunt.lieuDepotCorps}&lieu_naissance=${this.defunt.lieuNaiss}&adresse=${this.defunt.adresse}&cp=${this.defunt.cp}&localite=${this.defunt.loc}&etat_civil=${this.defunt.etatCivil}&nom_conjoint=${this.defunt.conjoint}&confession=${this.defunt.confession}&lieu_origine=${this.defunt.lieuOrigine}&profession=${this.defunt.profession}&filiation=${this.defunt.filiation}&remarque=${this.defunt.remarque}`).then((response)=>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.saveLoad = false
              this.$root.$emit('myinfo', {title: "Serenity", msg: "Erfolgreich gespeichert !", color: ""})
            }else{
              this.saveLoad = false
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        save(){
          setTimeout(() => {
            this.saveNext()
          }, 0)
        },
        querySelection(v){
          this.isLoadingAdress = true
          ajax("/PHP/ajax/returnAdress.php?val=" + v).then((response) =>{
            let adrReturn = JSON.parse(response)
            //on ajoute le descriptif pour voir l'adresse et la localité dans la liste déroulante 
            this.itemsAdr = adrReturn.map(res => ({...res, descript: res.adresse + " / " + res.loc}))
            this.isLoadingAdress = false
          })
        },
        querySelectionOrigin(v){
          this.isLoadingOrigin = true
          ajax("/PHP/ajax/returnOrigin.php?val=" + v).then((response) =>{
            let locReturn = JSON.parse(response)
            this.itemsOr = locReturn.filter(e => {
              return (e || '')
            })
            this.isLoadingOrigin = false
          })
        }
      },
      created () {
        this.fetchData()
      },
      watch: {
        '$route': 'fetchData',
        lieuOrigine(val){
          val && val.length > 2 && val !== this.defunt.lieuOrigine && this.querySelectionOrigin(val)
        },
        autoAdress(val){
          val && val.length > 3 && val !== this.defunt.adresse && this.querySelection(val)
        }
      }
    }
</script>